import { generateClient } from "aws-amplify/data";
import { QueryClient } from "@tanstack/react-query";
import type { Schema } from "../amplify/data/resource";

export const queryClient = new QueryClient();

export const client = generateClient<Schema>();

export const publicClient = generateClient<Schema>({
  authMode: "identityPool",
});

export type { Schema } from "../amplify/data/resource";

export enum QueryKeys {
  Users = "users",
  CognitoUsers = "cognitoUsers",
  Expansions = "expansions",
  ExpansionsShortened = "expansionsShortened",
  Products = "products",
  ProductsShortened = "productsShortened",
  ProductNames = "productNames",
  ProductNamesShortened = "productNamesShortened",
  ExpansionProducts = "expansionProducts",
  GlobalSettings = "globalSettings",
  CalcTasks = "calcTasks",
  CardmarketCalcTasks = "cardmarketCalcTasks",
  StockTasks = "stockTasks",
  SyncTasks = "syncTasks",
  /**
   * Eigener Namensraum für die Listen laufender Aufgaben.
   *
   * Absichtlich NICHT [CalcTasks, "running"]: TanStack invalidiert über
   * Präfix-Match, und die Create-Hooks invalidieren [CalcTasks]. Ein Unterschlüssel
   * würde dadurch mit-invalidiert, sofort über einen eventual-consistenten GSI
   * neu geladen und könnte die gerade erzeugte Pending-Zeile verlieren - die
   * Start-Buttons gingen wieder auf und man startet doppelt.
   */
  RunningTasks = "runningTasks",
}
